<template>
  <!--设施与服务-->
  <div class="facility-wrap">
    <div class="facility-title">设施</div>
    <div class="facility-content-wrap" v-if="info.facility">
        <div class="facility-content"  :class="{'facility-content-more':tabFacility}">
            <div v-for="item in info.facility.split(',')" class="facility-item" :key="item">
                <i :class="['iconfont',$options.filters['formatVar'](item,'FacilitiesBasiciconclass','iconClass')]"></i>
                <div>
                    {{ item | formatVar('FacilitiesBasiciconclass')}}
                </div>
            </div>
           
        </div>
         <div class="facility-more" v-if="info.facility.split(',').length >= 10" @click="tabFacility=!tabFacility">
            {{tabFacility?'收起':'查看'}}更多 
            <i class=" iconfont icon-shixinjiantouxiangxia" :class="{'icon-shixinjiantouxiangshang':tabFacility}"></i>
        </div>
    </div>
    <div class="facility-title" v-if="info.service">服务</div>
    <div class="facility-content-wrap" v-if="info.service">
        <div class="facility-content"  :class="{'facility-content-more':tabService}">
            <div v-for="item in info.service.split(',')" class="facility-item" :key="item">
                <i :class="['iconfont',$options.filters['formatVar'](item,'Facilitiesflsec','iconClass')]"></i>
                <div>
                    {{ item | formatVar('Facilitiesflsec')}}
                </div>
            </div>
        </div>
        <div class="facility-more" v-if="info.service.split(',').length >= 10" @click="tabService=!tabService">
             {{tabService?'收起':'查看'}}更多 
            <i class=" iconfont icon-shixinjiantouxiangxia" :class="{'icon-shixinjiantouxiangshang':tabService}"></i>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Facility',
  components: {},
  props: {
    info: {
        type: Object,
        default: () => ({})
    },
  },
  data() {
    return {
        activeName: 'first',
        tabFacility: false,
        tabService: false,
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
        handleClick(tab, event) {
            console.log(tab, event);
        },
        srcs(){

        },
  }
};
</script>

<style lang="scss" scoped>
.facility-wrap{
    width: 100%;
    margin: 0 auto;
}
.facility-content{
    display:flex;
    flex-wrap: wrap;
    justify-content: left;
    width: 100%;
    max-height: 165px;
    overflow: hidden;
}
.facility-content-wrap{
    background-color: #fff;
    padding: 0 1%;
    padding-top: 12px;
    border-radius: 6px;
}
.facility-item{
    width: calc(20% - 12px);
    margin-right: 15px;
    margin-bottom: 12px;
    padding: 12px 0;
    border-radius: 6px;
    text-align: center;
    i{
        font-size: 24px;
    }
    >div{
        margin-top: 6px;
    }
}
.facility-content  .facility-item:nth-child(5n){
    margin-right: 0;
}
.facility-title{
    width: 100%;
    font-size: 20px;
    font-weight: bold;
    text-align: left;
    margin: 10px 0;
}
.facility-more{
    text-align:center;
    padding-bottom: 10px;
    color: var(--smtc-color-primary); 
    cursor: pointer;
    i{
        font-size: 14px;
    }
}
.facility-content-more{
    max-height:none;
}
</style>
<style>
.facility-wrap .el-tabs__item{
    font-size: 16px;
}
</style>